import { IUser } from './user'

export interface ILocation {
  id: number
  code: string
  description?: string | null
  locationType: string
  accountId: number
  totalValue?: number
  user?: IUser | null
  userId?: number | null
  isDefault?: boolean
  cycleCountDue?: boolean
  latestCycleCount?: {
    id: number
    status: string
    completedAt?: string | null
    countedAt?: string | null
  } | null
  cycleCountStartDate?: string | null
  cycleCountFrequencyDays?: number | null
  nextCycleCountDate?: string | null
  createdAt: string
  updatedAt: string
  branches?: any[]
}

export interface ILocationItem {
  id: number
  locationId: number
  productId: number
  product: any
  quantity: number
  inventory?: number
  price?: number
  unit?: string
  threshold?: number | null
  location?: {
    id: number
    code: string
    description?: string | null
    locationType?: string
    isDefault?: boolean
    user?: { id: number; name: string } | null
  }
  createdAt: string
  updatedAt: string
}

export enum LocationTypes {
  TRUCK = 'truck',
  BIN = 'bin',
}

export const LOCATION_TYPE_LABELS: Record<string, string> = {
  [LocationTypes.TRUCK]: 'Truck',
  [LocationTypes.BIN]: 'Bin',
}

export const LOCATION_TYPE_PLURAL_LABELS: Record<string, string> = {
  [LocationTypes.TRUCK]: 'Trucks',
  [LocationTypes.BIN]: 'Bins',
}

export interface ILocationCreateAttributes {
  code: string
  description?: string
  locationType: string
  accountId: number
  userId?: number | null
  branchIds?: number[]
  cycleCountStartDate?: string | null
  cycleCountFrequencyDays?: number | null
}

export interface ILocationUpdateAttributes {
  code?: string
  description?: string
  locationType?: string
  accountId: number
  userId?: number | null
  branchIds?: number[]
  cycleCountStartDate?: string | null
  cycleCountFrequencyDays?: number | null
}

export interface ILocationFormValues {
  code: string
  description: string
  locationType: string
  userId: number | null
  cycleCountStartDate: string
  cycleCountFrequencyDays: string
}

export interface IAssignableUser {
  id: number
  name: string
}

export interface IUserOption {
  value: number
  label: string
  isDisabled?: boolean
}
